(function () {
  function addDesktopMoreMenu() {
    var list = document.querySelector('.main-menu > nav > ul');
    if (!list || list.querySelector('.km-more-menu')) return;

    var links = [
      {
        href: '/pages/cambio-kinetic',
        label: 'Cambio Kinetic',
        description: 'Tu m&oacute;vil antiguo paga el nuevo',
        icon: '<path d="M20 7h-9"/><path d="M14 17H5"/><circle cx="17" cy="17" r="3"/><circle cx="7" cy="7" r="3"/>'
      },
      {
        href: '/pages/tamano-real',
        label: 'Tama&ntilde;o Real',
        description: 'Compara dos m&oacute;viles a escala',
        icon: '<path d="M4 4h16v16H4z"/><path d="M8 4v4M12 4v2M16 4v4M4 8h4M4 12h2M4 16h4"/>'
      },
      {
        href: '/pages/explora-por-precio',
        label: 'Explora por precio',
        description: 'Descubre qu&eacute; encaja en tu presupuesto',
        icon: '<path d="M3 5h18M3 12h18M3 19h18"/><circle cx="8" cy="5" r="2"/><circle cx="16" cy="12" r="2"/><circle cx="10" cy="19" r="2"/>'
      },
      {
        href: '/pages/pack-inteligente',
        label: 'Pack Inteligente',
        description: 'Protecci&oacute;n vinculada a tu modelo',
        icon: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.27 6.96 12 12.01l8.73-5.05M12 22.08V12"/>'
      },
      {
        href: '/pages/reserva-en-tienda',
        label: 'Reserva en tienda',
        description: 'Ven a verlo antes de decidir',
        icon: '<rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/>'
      },
      {
        href: '/pages/guias-de-compra',
        label: 'Gu&iacute;as de compra',
        description: 'Compara y elige con criterio',
        icon: '<path d="M2 4h6a4 4 0 0 1 4 4v12a3 3 0 0 0-3-3H2z"/><path d="M22 4h-6a4 4 0 0 0-4 4v12a3 3 0 0 1 3-3h7z"/>'
      },
      {
        href: '/blogs/news',
        label: 'Actualidad',
        description: 'Consejos, novedades y comparativas',
        icon: '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/><path d="M8 7h8M8 11h6"/>'
      },
      {
        href: '/pages/contact',
        label: 'Habla con nosotros',
        description: 'Atenci&oacute;n directa desde Barcelona',
        icon: '<path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"/><path d="M8 9h8M8 13h5"/>'
      }
    ];
    var item = document.createElement('li');
    item.className = 'km-more-menu';
    item.innerHTML = '<button class="km-more-menu__trigger" type="button" aria-expanded="false"><span>Servicios</span><svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M2 3.5 5 6.5 8 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button><div class="km-more-menu__panel"><div class="km-more-menu__heading"><span>Kinetic Lab</span><strong>Herramientas para elegir mejor</strong></div><ul class="km-more-menu__list"></ul><a class="km-more-menu__footer" href="/pages/encuentra-tu-movil-ideal"><span>Abrir Kinetic Match</span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a></div>';
    var submenu = item.querySelector('.km-more-menu__list');
    links.forEach(function (entry) {
      var child = document.createElement('li');
      child.innerHTML = '<a href="' + entry.href + '"><span class="km-more-menu__icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + entry.icon + '</svg></span><span class="km-more-menu__copy"><strong>' + entry.label + '</strong><small>' + entry.description + '</small></span><svg class="km-more-menu__arrow" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg></a>';
      submenu.appendChild(child);
    });
    list.appendChild(item);

    var trigger = item.querySelector('.km-more-menu__trigger');
    trigger.addEventListener('click', function () {
      var open = item.classList.toggle('km-more-open');
      trigger.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', function (event) {
      if (item.contains(event.target)) return;
      item.classList.remove('km-more-open');
      trigger.setAttribute('aria-expanded', 'false');
    });
    item.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      item.classList.remove('km-more-open');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    });
  }

  function addMobileServicesMenu() {
    var list = document.querySelector('.mobile-navigation .mobile-menu');
    if (!list) return;

    var existing = list.querySelector('.km-mobile-services');
    if (existing) {
      existing.querySelectorAll(':scope > .menu-expand').forEach(function (legacyToggle) {
        legacyToggle.remove();
      });
      return;
    }

    var services = [
      { href: '/pages/cambio-kinetic', label: 'Cambio Kinetic' },
      { href: '/pages/tamano-real', label: 'Tamaño Real' },
      { href: '/pages/pack-inteligente', label: 'Pack Inteligente' },
      { href: '/pages/reserva-en-tienda', label: 'Reserva en tienda' }
    ];
    var item = document.createElement('li');
    item.className = 'km-mobile-services';
    item.innerHTML =
      '<button class="km-mobile-services__toggle" type="button" aria-expanded="false">' +
      '<span class="km-mobile-services__label"><span class="km-mobile-services__icon" aria-hidden="true">' +
      '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z"/></svg>' +
      '</span>Servicios</span><span class="km-mobile-services__plus" aria-hidden="true"></span></button>' +
      '<ul class="dropdown km-mobile-services__list"></ul>';

    var submenu = item.querySelector('.km-mobile-services__list');
    services.forEach(function (service) {
      var child = document.createElement('li');
      child.innerHTML = '<a href="' + service.href + '"><span>' + service.label + '</span><span aria-hidden="true">›</span></a>';
      submenu.appendChild(child);
    });

    var discoverLink = list.querySelector('a[href="/pages/descubre"]');
    var reference = discoverLink && discoverLink.closest('li');
    list.insertBefore(item, reference || null);

    var toggle = item.querySelector('.km-mobile-services__toggle');
    function setOpen(open) {
      item.classList.toggle('km-mobile-services--open', open);
      toggle.setAttribute('aria-expanded', String(open));
    }

    toggle.addEventListener('click', function () {
      setOpen(!item.classList.contains('km-mobile-services--open'));
    });
    item.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      setOpen(false);
      toggle.focus();
    });
  }

  function createMobileToolItem(className, href, label, meta, icon) {
    var item = document.createElement('li');
    item.className = 'km-mobile-tool ' + className;
    item.innerHTML =
      '<a href="' + href + '" aria-label="' + label + '">' +
      '<span class="km-mobile-tool__label">' +
      '<span class="km-mobile-tool__icon" aria-hidden="true">' +
      '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">' +
      icon + '</svg></span><span>' + label + '</span></span>' +
      '<span class="km-mobile-tool__meta"><span>' + meta + '</span>' +
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>' +
      '</span></a>';
    return item;
  }

  function addMobileCompareLink() {
    var list = document.querySelector('.mobile-navigation .mobile-menu');
    if (!list || list.querySelector('.km-mobile-compare')) return;

    var item = createMobileToolItem(
      'km-mobile-compare',
      '/pages/comparador',
      'Comparar tel&eacute;fonos',
      'Herramienta',
      '<rect x="3" y="4" width="6" height="16" rx="1.5"/><rect x="15" y="4" width="6" height="16" rx="1.5"/><path d="M10.5 9h3M12 7.5 13.5 9 12 10.5M13.5 15h-3M12 13.5 10.5 15 12 16.5"/>'
    );

    var matchLink = list.querySelector('a[href="/pages/encuentra-tu-movil-ideal"]');
    var matchItem = matchLink && matchLink.closest('li');
    if (matchItem) matchItem.insertAdjacentElement('afterend', item);
    else {
      var servicesItem = list.querySelector('.km-mobile-services');
      list.insertBefore(item, servicesItem || null);
    }
  }

  function addMobileExploreLink() {
    var list = document.querySelector('.mobile-navigation .mobile-menu');
    if (!list || list.querySelector('.km-mobile-explore')) return;

    var item = createMobileToolItem(
      'km-mobile-explore',
      '/pages/explora-por-precio',
      'Explora por precio',
      'Presupuesto',
      '<path d="M3 5h18M3 12h18M3 19h18"/><circle cx="8" cy="5" r="2"/><circle cx="16" cy="12" r="2"/><circle cx="10" cy="19" r="2"/>'
    );
    var compareItem = list.querySelector('.km-mobile-compare');
    if (compareItem) compareItem.insertAdjacentElement('afterend', item);
    else {
      var matchLink = list.querySelector('a[href="/pages/encuentra-tu-movil-ideal"]');
      var matchItem = matchLink && matchLink.closest('li');
      if (matchItem) matchItem.insertAdjacentElement('afterend', item);
      else list.appendChild(item);
    }
  }

  function addMobileWishlistLink() {
    var list = document.querySelector('.mobile-navigation .mobile-menu');
    if (!list || list.querySelector('.km-mobile-wishlist')) return;

    var item = createMobileToolItem(
      'km-mobile-wishlist',
      '/pages/wishlist',
      'Mis favoritos',
      'Guardados',
      '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8z"/>'
    );
    var contactLink = list.querySelector('a[href="/pages/contact"]');
    var contactItem = contactLink && contactLink.closest('li');
    if (contactItem) contactItem.insertAdjacentElement('afterend', item);
    else list.appendChild(item);
  }

  function enhanceAccessibility() {
    document.querySelectorAll('.footer__top__social__wrap a').forEach(function (link) {
      if (link.getAttribute('aria-label')) return;
      var href = link.getAttribute('href') || '';
      link.setAttribute('aria-label', href.indexOf('youtube') !== -1 ? 'Kinetic Mobiles en YouTube' : 'Red social de Kinetic Mobiles');
    });

    var scrollUp = document.getElementById('scrollUp');
    if (scrollUp) scrollUp.setAttribute('aria-label', 'Volver al inicio de la página');

    var cartButton = document.querySelector('button.icon-cart-active');
    if (cartButton) {
      var count = (cartButton.textContent || '').trim() || '0';
      cartButton.setAttribute('aria-label', 'Carrito, ' + count + ' productos');
    }

    document.querySelectorAll('.km-desc-banner, #km-gr-maps-link').forEach(function (link) {
      link.removeAttribute('aria-label');
    });

    var closeMenu = document.querySelector('a.mobile-aside-close:not([href])');
    if (closeMenu) {
      closeMenu.setAttribute('href', '#MainContent');
      closeMenu.setAttribute('aria-label', 'Cerrar menú');
      closeMenu.setAttribute('role', 'button');
    }

    var mobileAccount = document.querySelector('a.mobile-account-active');
    if (mobileAccount) {
      if (!mobileAccount.getAttribute('href')) mobileAccount.setAttribute('href', '/account');
      mobileAccount.setAttribute('aria-label', 'Mi cuenta');
    }
  }

  function initialize() {
    addDesktopMoreMenu();
    addMobileServicesMenu();
    addMobileCompareLink();
    addMobileExploreLink();
    addMobileWishlistLink();
    enhanceAccessibility();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  setTimeout(addDesktopMoreMenu, 800);
  setTimeout(addMobileServicesMenu, 800);
  setTimeout(addMobileCompareLink, 800);
  setTimeout(addMobileExploreLink, 800);
  setTimeout(addMobileWishlistLink, 800);
  setTimeout(enhanceAccessibility, 800);
  setTimeout(addMobileServicesMenu, 2200);
  setTimeout(addMobileCompareLink, 2200);
  setTimeout(addMobileExploreLink, 2200);
  setTimeout(addMobileWishlistLink, 2200);
  setTimeout(enhanceAccessibility, 2200);
})();

